import { isValid, lightFormat, parseISO } from 'date-fns';
import orderBy from 'lodash.orderby';

export const createOrderList = (data = []) => {
  const sortedData = orderBy(data, ['orderDate'], ['desc']);

  const mappedData = sortedData?.map(({ uid, crmOrderId, orderDate, products: orderProducts }) => {
    const mainProduct = orderProducts?.find(({ code: { main } }) => main);

    return {
      orderId: uid,
      crmOrderId,
      orderDate: isValid(parseISO(orderDate)) ? lightFormat(parseISO(orderDate), 'MM/dd/yyyy') : orderDate,
      description: orderProducts?.reduce((res, { code }, idx) => {
        if (idx > 0) {
          return `${res}, ${code?.customerName}`;
        }

        return code?.customerName;
      }, ''),
      status: mainProduct?.processingResult?.status,
      processingOption: mainProduct?.processingOption,
    };
  });

  return mappedData;
};
